module.exports = __webpack_public_path__ + "img/download.4051444c.svg";